import { render } from "./SelectionFormTal.vue?vue&type=template&id=d27fe1d2"
import script from "./SelectionFormTal.vue?vue&type=script&lang=js"
export * from "./SelectionFormTal.vue?vue&type=script&lang=js"

import "./SelectionFormTal.vue?vue&type=style&index=0&id=d27fe1d2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__